import { render, staticRenderFns } from "./RepairsIdlePerPeriodByASF.vue?vue&type=template&id=05940a9d"
import script from "./RepairsIdlePerPeriodByASF.vue?vue&type=script&lang=js"
export * from "./RepairsIdlePerPeriodByASF.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports